import React, { FunctionComponent } from "react";

const ArrowsLeftIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/arrows-diagrams/arrows/arrow-left-1
  return (
    <svg viewBox="-0.75 -0.75 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.234375 21.796875 5.184375 11.746875a0.7021875 0.7021875 0 0 1 0 -0.99375L15.234375 0.703125"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default ArrowsLeftIcon;
